export const FETCH_PRODUCTS_LOCATION_REQUESTED = 'FETCH_PRODUCTS_LOCATION_REQUESTED';
export const FETCH_PRODUCTS_LOCATION_SUCCEEDED = 'FETCH_PRODUCTS_LOCATION_SUCCEEDED';
export const SEARCH_PRODUCT_LOCATION_REQUESTED = 'SEARCH_PRODUCT_LOCATION_REQUESTED';
export const SEARCH_PRODUCT_LOCATION_SUCCEEDED = 'SEARCH_PRODUCT_LOCATION_SUCCEEDED';
export const FETCH_TRACKED_PRODUCTS_REQUESTED = 'FETCH_TRACKED_PRODUCTS_REQUESTED';
export const FETCH_TRACKED_PRODUCTS_SUCCEEDED = 'FETCH_TRACKED_PRODUCTS_SUCCEEDED';
export const COMPLETE_SCAN_REQUESTED = 'COMPLETE_SCAN_REQUESTED';
export const COMPLETE_SCAN_SUCCEEDED = 'COMPLETE_SCAN_SUCCEEDED';
export const FETCH_EXTRA_PRODUCT_REQUESTED = 'FETCH_EXTRA_PRODUCT_REQUESTED';
export const FETCH_EXTRA_PRODUCT_SUCCEEDED = 'FETCH_EXTRA_PRODUCT_SUCCEEDED';
export const UPDATE_SORT_BY_STATUS_DIRECTION = 'UPDATE_SORT_BY_STATUS_DIRECTION';
export const MAP_CURRENT_LOCATION_TO_PRODUCT = 'MAP_CURRENT_LOCATION_TO_PRODUCT';
export const FETCH_ALL_LOCATIONS = 'FETCH_ALL_LOCATIONS';
export const FETCH_CURRENT_LOCATION = 'FETCH_CURRENT_LOCATION';
export const SCAN_RACK_MOVING_PRODUCT_LOCATION = 'SCAN_RACK_MOVING_PRODUCT_LOCATION';
export const MARKED_AS_FOUND_REQUESTED = 'MARKED_AS_FOUND_REQUESTED';
export const MARKED_AS_FOUND_SUCCEEDED = 'MARKED_AS_FOUND_SUCCEEDED';
export const FETCH_LOCATION_OF_TRACKED_PRODUCT_REQUESTED = 'FETCH_LOCATION_OF_TRACKED_PRODUCT_REQUESTED';
export const FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED = 'FETCH_LOCATION_OF_TRACKED_PRODUCT_SUCCEEDED';
export const SCAN_RACK_UPDATE_PRODUCT_DESTINATION = 'SCAN_RACK_UPDATE_PRODUCT_DESTINATION';
export const SCAN_RACK_UPDATE_PRODUCT_LOCATION = 'SCAN_RACK_UPDATE_PRODUCT_LOCATION';
export const REMOVE_SCANNED_ITEM = 'REMOVE_SCANNED_ITEM';
export const REMOVE_SCANNED_ITEM_SUCCEEDED = 'REMOVE_SCANNED_ITEM_SUCCEEDED';
export const MOVE_ITEM_TO_LOST_AND_FOUND_DESTINATION = 'MOVE_ITEM_TO_LOST_AND_FOUND_DESTINATION';
export const RESET_SCAN_REQUESTED = 'RESET_SCAN_REQUESTED';
export const RESET_SCAN_SUCCESSED = 'RESET_SCAN_SUCCESSED';


